import React from 'react';

import ActivityWhatsapp from 'components/Tvendo/Reports/Activity/list.js';

export default function () {
  return <ActivityWhatsapp />;
}
